import ls from "localstorage-slim";
import { isBrowser } from "../environment";

/**
 * The stored navigation-menu collapse state, read synchronously so the menu
 * and its loading placeholder both start in the state the user left it in.
 * Expanded unless the user collapsed it.
 */
export const getStoredSidebarCollapsed = (): boolean => {
  if (isBrowser()) {
    return ls.get<boolean>("sideBarCollapsed") ?? false;
  }
  return false;
};
